import styled from 'styled-components'
const NetworkRequestsContainer = styled.div`
  overflow-y: auto;

  .heading{
    text-align: center;
  }
  thead {
    th {
      position: sticky;
      top: 0;
      border-top: none;
    }
  }
  .noRecordFound{
    text-align: center;
    margin-top: 25%;
    width: 100%;
    position: absolute;
  }
  table {
    border-collapse: collapse;
    width: 100%;
  }
  button {
    display: inline-flex;
    margin-right: 5px;
  }
  tbody {
    max-height: 300px;
    overflow: scroll;
  }
  th,
  td {
    padding: 8px 16px;
  }
  th {
    background: #eee;
  }

`


export { NetworkRequestsContainer}
